define.alias("shared/utils/delete-media-item", "calendar/utils/delete-media-item");